import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./review_slider.css";

const ReviewsSlider = () => {
    // State to track which review is currently in the modal
    const [modalReview, setModalReview] = useState(null);

    const reviews = [
        {
            name: "John D.",
            stars: 5,
            service: "Sub-Zero fridge repair",
            description:
                "I recently had my Sub-Zero refrigerator repaired, and I’m beyond impressed with the service. \
                The technician arrived right on time and diagnosed the issue immediately. Not only was the repair completed quickly, \
                but they also took the time to explain what went wrong in simple terms. Throughout the process, \
                I felt confident in their expertise and attention to detail. My fridge is running perfectly now, \
                and I no longer have to worry about spoiled groceries. I’m incredibly thankful for their professionalism and fast turnaround.",
            timeAgo: "2 days ago",
            photo: "/images/review1.png"
        },
        {
            name: "Lisa R.",
            stars: 4,
            service: "Sub-Zero wine cooler repair",
            description: "I reached out for Sub-Zero wine cooler repair near me after it stopped holding temperature. \
            Their certified Sub-Zero technician arrived the same day, diagnosed the issue quickly, and completed the repair in under an hour. \
            The wine cooler runs perfectly now, and the whole process was smooth and professional. \
            I’ll definitely use them again for any high-end appliance repair service.",
            timeAgo: "14 days ago",
            photo: "/images/review1.png"
        },
        {
            name: "Alex K.",
            stars: 5,
            service: "Wolf oven and Cove ventilation system repair",
            description: "I booked service for my Wolf oven and Cove ventilation system, both having minor issues. \
            The technician showed up on time, cleaned and fixed both appliances with care, and everything works like new. \
            If you’re looking for reliable Wolf or Cove appliance repair near you, this is the team to call.",
            timeAgo: "2 months ago",
            photo: "/images/review1.png"
        }
    ];

    // Show the modal with full review details
    const openModal = (review) => {
        setModalReview(review);
    };

    // Hide the modal
    const closeModal = () => {
        setModalReview(null);
    };

    // Helper to render star icons
    const renderStars = (count) => {
        return [...Array(5)].map((_, starIdx) => {
            const isFilled = starIdx < count;
            return (
                <span
                    key={starIdx}
                    className={isFilled ? "star star-filled" : "star star-empty"}
                >
                    ★
                </span>
            );
        });
    };

    return (
        <section className="reviews-slider">
            <h2 className="reviews-title">CUSTOMERS FEEDBACK</h2>

            <Swiper
                modules={[Navigation, Pagination]}
                navigation
                pagination={{ clickable: true }}
                slidesPerView={1}
                spaceBetween={50}
            >
                {reviews.map((review, index) => (
                    <SwiperSlide key={index}>
                        <div className="review-slide">
                            <div className="review-top-row">
                                <div className="slide-image">
                                    <img
                                        src={review.photo}
                                        alt={review.name}
                                    />
                                </div>

                                <div className="slide-meta">
                                    <h3 className="reviewer-name">
                                        {review.name}
                                    </h3>

                                    <div className="review-stars">
                                        {renderStars(review.stars)}
                                        <span className="review-time-ago">
                                            {review.timeAgo}
                                        </span>
                                    </div>

                                    <p className="review-service">
                                        <strong>Service:</strong>{" "}
                                        {review.service}
                                    </p>
                                </div>
                            </div>
                            <div
                                className="review-description truncated-text"
                                onClick={() => openModal(review)}
                            >
                                {review.description}
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>

            {modalReview && (
                <div className="review-modal" onClick={closeModal}>
                    {/* Prevent click inside from closing the modal */}
                    <div
                        className="review-modal-content"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button className="modal-close-btn" onClick={closeModal}>
                            &times;
                        </button>

                        {/* Replicate the layout within the modal */}
                        <div className="modal-review-top-row">
                            <div className="modal-slide-image">
                                <img
                                    src={modalReview.photo}
                                    alt={modalReview.name}
                                />
                            </div>

                            <div className="modal-slide-meta">
                                <h3 className="modal-reviewer-name">
                                    {modalReview.name}
                                </h3>
                                <div className="modal-review-stars">
                                    {renderStars(modalReview.stars)}
                                    <span className="modal-review-time-ago">
                                        {modalReview.timeAgo}
                                    </span>
                                </div>
                                <p className="modal-review-service">
                                    <strong>Service:</strong>{" "}
                                    {modalReview.service}
                                </p>
                            </div>
                        </div>

                        <p className="modal-full-description">
                            {modalReview.description}
                        </p>
                    </div>
                </div>
            )}
        </section>
    );
};

export default ReviewsSlider;